module.exports = __webpack_public_path__ + "static/media/pre-calculated.d0cedc3b.jpg";